import type { MouseEvent } from 'react'

/**
 * 「줄 아무 데나 눌러서 연다」의 공통 판정 — 표의 `<tr>` 과 랩웨어 카드(`<li>`)가 같이 쓴다.
 *
 * eric 2026-09-23 「해당 row 의 어떤 부분을 클릭해도 상세 페이지가 보이게 해줘.
 * 요약 PDF 나 시료 CSV 는 물론 그 버튼이 우선순위가 높고.」
 *
 * 🔴 **마우스·터치용 «보태기»다. 키보드 경로가 아니다.** 첫 칸(카드는 제목)의 진짜 `button` 이
 *    그 일을 계속 한다 — 줄 자체에 `tabIndex`·`role="button"` 을 달지 마라. 표의 시맨틱이
 *    깨지고 스크린리더가 행마다 「버튼」을 읽는다(§11-4-7 의 답이 그 첫 칸 버튼이다).
 */

/**
 * 줄 클릭을 **삼키는** 요소들 — 이 안에서 시작한 클릭은 줄을 열지 않는다.
 * 제 핸들러가 있는 것들이라, 줄이 가로채면 그 단추가 눌리고도 화면이 통째로 바뀐다.
 */
const INTERACTIVE_IN_ROW =
  'button,a,input,select,textarea,label,[role="button"],[role="radio"],[role="checkbox"]'

/**
 * 이 클릭이 «줄 열기»인가.
 *
 * 🔴 두 가지를 거른다 — ⓐ 줄 안의 단추·링크·입력에서 시작한 클릭 ⓑ 글자를 끌어 고른 뒤의 클릭.
 *    ⓑ 가 없으면 값을 복사하려고 드래그한 것이 상세 열기로 읽힌다.
 * ⚠ 상호작용 요소는 **그 줄 안에 있을 때만** 센다. 줄이 통째로 `label`·`a` 안에 들어가 있어도
 *   줄 클릭은 살아야 한다.
 */
export function isPlainRowClick<E extends HTMLElement>(event: MouseEvent<E>): boolean {
  const row = event.currentTarget

  if (event.target instanceof Element) {
    const hit = event.target.closest(INTERACTIVE_IN_ROW)
    if (hit !== null && row.contains(hit)) return false
  }

  const selection = window.getSelection()
  if (selection !== null && selection.toString() !== '') {
    const anchor = selection.anchorNode
    if (anchor !== null && row.contains(anchor)) return false
  }

  return true
}
